import { render, staticRenderFns } from "./AccountTypeFunction.vue?vue&type=template&id=6262fa61"
import script from "./AccountTypeFunction.vue?vue&type=script&lang=js"
export * from "./AccountTypeFunction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports